module.exports = __webpack_public_path__ + "fonts/roboto-regular.30b5765.eot";